import { FC } from "react"
import cn from "classnames"
import { Box, Button, Flex, Text, useThemeStore, Callout } from "@stoplight/mosaic"
import { NavLink, useLocation } from "react-router-dom"

import { NINJA_LOGO_COLORS } from "../constants"

const NavItem: FC<{
  to: string
  label: string
  isActive?: boolean
}> = ({ label, to, isActive = false }) => (
  <NavLink
    exact
    to={to}
    className={cn("sl-rounded sl-ml-1 sl-px-2.5 sl-py-1.5", {
      "sl-bg-ninja": isActive,
      "hover:sl-bg-canvas-200": !isActive,
    })}
  >
    <Text
      // @ts-expect-error
      color={isActive ? "white" : "current"}
      fontSize="lg"
      fontWeight="semibold"
      lineHeight="none"
    >
      {label}
    </Text>
  </NavLink>
)

export default function TopNav() {
  const { mode, setMode } = useThemeStore()
  const { pathname } = useLocation()

  return (
    <Box as="header" bg="canvas" w="full" mx="auto" className="sl-fixed sl-top-0 sl-z-30">
      <Flex as="nav" py={2} px={6} justifyContent="between" alignItems="center" w="full" className="sl-border-b">
        <Flex alignItems="center">
          <NavLink to="/" className="sl-flex sl-items-center">
            <svg viewBox="0 0 1056.36 228.17" className="sl-block sl-h-6 sl-mt-1">
              <path
                fill={mode === "light" ? NINJA_LOGO_COLORS.letters : "currentColor"}
                d="M113.16,60.12Q127.4,74.78,127.4,103.6v75.23H91.27V109.46q0-15.63-6.49-23.33T66,78.44q-13.66,0-21.77,8.91t-8.11,26.5v65H0V58.41L34.52,41.92V62.81A47.68,47.68,0,0,1,52.35,50a59.21,59.21,0,0,1,23.4-4.53Q98.91,45.46,113.16,60.12Z"
              />
              <path
                fill={mode === "light" ? NINJA_LOGO_COLORS.letters : "currentColor"}
                d="M154.29,58.43V178.84h36.12V41.94Z"
              />
              <polygon
                fill={mode === "light" ? NINJA_LOGO_COLORS.letters : "currentColor"}
                points="190.41 0.03 190.41 30.93 154.29 47.41 154.29 16.52 190.41 0.03"
              ></polygon>
              <polygon
                fill={mode === "light" ? NINJA_LOGO_COLORS.letters : "currentColor"}
                points="371.21 16.55 371.21 47.45 407.32 30.9 407.32 0 371.21 16.55"
              ></polygon>
              <path
                fill={mode === "light" ? NINJA_LOGO_COLORS.letters : "currentColor"}
                d="M331.36,60.12Q345.6,74.78,345.6,103.6v75.23H309.47V109.46q0-15.63-6.49-23.33t-18.76-7.69q-13.67,0-21.77,8.91t-8.11,26.5v65H218.2V58.41l34.52-16.49V62.81A47.68,47.68,0,0,1,270.55,50,59.21,59.21,0,0,1,294,45.46Q317.11,45.46,331.36,60.12Z"
              />
              <path
                fill={mode === "light" ? NINJA_LOGO_COLORS.letters : "currentColor"}
                d="M407.33,42.26V178.58q0,23-12.39,36.29t-34.64,13.3q-19,0-28.94-7.32l9.71-27.6q6.26,4.63,15.29,4.62c4.64,0,8.25-1.57,10.89-4.75s3.94-7.94,3.94-14.29v-120Z"
              />
              <path
                fill={mode === "light" ? NINJA_LOGO_COLORS.letters : "currentColor"}
                d="M561.36,58.41V178.83H526.84V163.68q-13.44,17.12-38.91,17.1a62,62,0,0,1-31.85-8.3,58,58,0,0,1-22.35-23.7q-8.12-15.37-8.11-35.66t8.11-35.66a58,58,0,0,1,22.35-23.69,62,62,0,0,1,31.85-8.31q23.85,0,37.29,15.88V41.92Zm-44.48,81.21q9-9.88,9-26.5t-9-26.5a29.42,29.42,0,0,0-22.7-9.89q-13.89,0-22.93,9.89t-9,26.5q0,16.62,9,26.5t22.93,9.89A29.42,29.42,0,0,0,516.88,139.62Z"
              />
              <path
                fill={NINJA_LOGO_COLORS.logo}
                d="M624.48,170.28a82.82,82.82,0,0,1-31.74-31.64q-11.46-20.14-11.46-45.3T592.74,48A82.86,82.86,0,0,1,624.48,16.4Q644.75,4.93,670,4.92T715.39,16.4A83.83,83.83,0,0,1,747.13,48q11.58,20.14,11.58,45.31t-11.58,45.3a83.79,83.79,0,0,1-31.74,31.64Q695.25,181.76,670,181.76T624.48,170.28Zm71.46-29.19a48.84,48.84,0,0,0,18.19-19.42,59.66,59.66,0,0,0,6.6-28.33A59.66,59.66,0,0,0,714.13,65a48.93,48.93,0,0,0-18.19-19.43,51.84,51.84,0,0,0-51.89,0A48.84,48.84,0,0,0,625.87,65a59.55,59.55,0,0,0-6.61,28.33,59.55,59.55,0,0,0,6.61,28.33,48.75,48.75,0,0,0,18.18,19.42,51.84,51.84,0,0,0,51.89,0Z"
              />
              <path
                fill={NINJA_LOGO_COLORS.logo}
                d="M891.79,60.12Q906,74.78,906,103.6v75.23H869.89V109.46q0-15.63-6.48-23.33t-18.76-7.69q-13.67,0-21.77,8.91t-8.12,26.5v65H778.63V58.41l34.52-16.49V62.81A47.68,47.68,0,0,1,831,50a59.18,59.18,0,0,1,23.4-4.53Q877.52,45.46,891.79,60.12Z"
              />
              <path
                fill={NINJA_LOGO_COLORS.logo}
                d="M971.12,79.85q-8.34,7.32-10.19,20h61.38q-1.86-12.45-10.19-19.9a29.51,29.51,0,0,0-20.39-7.46Q979.46,72.51,971.12,79.85Zm76.33,78Q1029.87,179,996.12,179c-14,0-26.48-2.91-37.27-8.68a61.1,61.1,0,0,1-25-24.08Q925,130.92,925,111.36a70,70,0,0,1,8.7-34.79,62.35,62.35,0,0,1,23.82-24.18,70.45,70.45,0,0,1,67.07-.39,59.27,59.27,0,0,1,23.3,23.8c5.63,10.39,8.44,22.37,8.44,36.05,0,.5-.26,3.9-.67,10.22H961.41a30.87,30.87,0,0,0,12,19.35c6.31,4.72,14.18,7,23.61,7a45.61,45.61,0,0,0,17.26-3,30.17,30.17,0,0,0,3.54-1.7Z"
              />
            </svg>
            <Text
              // @ts-expect-error
              color={mode === "light" ? "ninja" : "current"}
              fontSize="2xl"
              fontWeight="semibold"
              lineHeight="none"
              pl={1.5}
            >
              Public API
            </Text>
            <Text
              // @ts-expect-error
              color={mode === "light" ? "ninja" : "current"}
              fontSize="xs"
              fontWeight="bold"
              pt={2}
              pl={0.5}
            >
              BETA
            </Text>
          </NavLink>
          <Button
            title="Toggle theme"
            size="sm"
            className="sl-ml-1 sl-border-none hover:sl-bg-canvas hover:sl-text-ninja active:sl-bg-canvas"
            onClick={() => setMode(mode === "dark" ? "light" : "dark")}
          >
            {mode === "dark" ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path d="M8,2 C4.5,2.9 2,6.1 2,9.9 C2,14.4 5.6,18 10.1,18 C13.9,18 17,15.5 18,12 C11.9,13.7 6.3,8.1 8,2 Z" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <rect width="2" height="2" x="9" y="2" />
                <rect width="2" height="2" x="13.88" y="4.051" transform="rotate(45.02 14.88 5.051)" />
                <rect width="2" height="2" x="16" y="9" />
                <rect width="2" height="2" x="13.949" y="14.019" transform="rotate(-135.02 14.95 15.019)" />
                <rect width="2" height="2" x="9" y="16" />
                <rect width="2" height="2" x="3.98" y="13.949" transform="rotate(-134.98 4.98 14.95)" />
                <rect width="2" height="2" x="2" y="9" />
                <rect width="2" height="2" x="4.05" y="4.121" transform="rotate(44.98 5.05 5.12)" />
                <path d="M10,6 C7.8,6 6,7.8 6,10 C6,12.2 7.8,14 10,14 C12.2,14 14,12.2 14,10 C14,7.8 12.2,6 10,6 Z" />
              </svg>
            )}
          </Button>
        </Flex>
        <Flex alignItems="center">
          <Callout
            intent="info"
            icon="info-circle"
            alignItems="center"
            fontWeight="semibold"
            fontSize="lg"
            actions={
              <NavLink to="/upcoming-changes" className="sl-flex sl-items-center sl-pl-12">
                <Text size="lg" color={mode === "light" ? "primary-darker" : "primary-light"}>
                  Details
                  <span aria-hidden="true"> →</span>
                </Text>
              </NavLink>
            }
          >
            API coming changes
          </Callout>
        </Flex>
        <Flex p={2} justifyContent="between" alignItems="center">
          <NavItem to="/authorization/overview" label="Authorization" isActive={pathname.includes("/authorization")} />
          <NavItem to="/core-resources" label="Core Resources" isActive={pathname.includes("/core-resources")} />
          <a className="sl-ml-1 sl-px-2.5 sl-py-1.5 hover:sl-bg-canvas-200" href="/apidocs/">
            <Text color="current" fontSize="lg" fontWeight="semibold" lineHeight="none">
              Return to previous site →
            </Text>
          </a>
        </Flex>
      </Flex>
    </Box>
  )
}
